export enum EntityType {
  CASE = 'LNG_REFERENCE_DATA_CATEGORY_PERSON_TYPE_CASE',
  CONTACT = 'LNG_REFERENCE_DATA_CATEGORY_PERSON_TYPE_CONTACT',
  CONTACT_OF_CONTACT = 'LNG_REFERENCE_DATA_CATEGORY_PERSON_TYPE_CONTACT_OF_CONTACT',
  EVENT = 'LNG_REFERENCE_DATA_CATEGORY_PERSON_TYPE_EVENT'
}
